import Drawer from "../../../../../drawer/Drawer";
import SaleDetails from "../OrderEarningTable";

const OrderEarningDrawer = ({ open, close = () => {}, data = {} }) => {
  return (
    <Drawer
      open={open}
      onClose={close}
      actualSize={"lg"}
      size={"xl4"}
      title={
        <span className="tracking-tighter uppercase font-bold">
          Sale Details
        </span>
      }
      subtitle="View detailed promoter information and commission settings"
      drawerBodyClass="p-0 max-h-[calc(100%-85px)] overflow-y-auto scrollbar"
    >
      <SaleDetails data={data} />
    </Drawer>
  );
};

export default OrderEarningDrawer;
